import TestResults2022 from './TestResults/2022TestResults.pdf';
import TestResults1 from './TestResults/HerdTestResults2021-1.pdf';
import TestResults2 from './TestResults/HerdTestResults2021-2.pdf';

export default {
	Test1: TestResults2022,
	Test2: TestResults1,
	Test3: TestResults2
};
